interface Source {
  name: string
  type: string
  path: string
}

const sources: Source[] = [
  {
    name: 'lowBackrest',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_bl.glb',
  },
  {
    name: 'highBackrest',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_bh.glb',
  },
  {
    name: 'lowBackrestCorner',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_cil.glb',
  },
  {
    name: 'highBackrestCorner',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_cih.glb',
  },
  {
    name: 'lowBackrestInnerCorner',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_col.glb',
  },
  {
    name: 'highBackrestInnerCorner',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_coh.glb',
  },
  {
    name: 'lowBackrestWide',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_blw.glb',
  },
  {
    name: 'highBackrestWide',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_bhw.glb',
  },
  {
    name: 'pillow',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_bo.glb',
  },
  {
    name: 'pillowWide',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_bow.glb',
  },
  {
    name: 'pillowCornerInner',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_bo_ci.glb',
  },
  {
    name: 'pillowCornerOuter',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_bo_co.glb',
  },
  {
    name: 'seat',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_s.glb',
  },
  {
    name: 'seatWide',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_sw.glb',
  },
  {
    name: 'table',
    type: 'gltfModel',
    path: '/3d_models/nido_ni_tp.glb',
  },
  {
    name: 'socket',
    type: 'gltfModel',
    path: '/3d_models/nido_di_e_cz.glb',
  },
  {
    name: 'cageSingle',
    type: 'gltfModel',
    path: '/3d_models/nido_cage_1.glb',
  },
  {
    name: 'cageDouble',
    type: 'gltfModel',
    path: '/3d_models/nido_cage_2.glb',
  },
  {
    name: 'cageTriple',
    type: 'gltfModel',
    path: '/3d_models/nido_cage_3.glb',
  },
  {
    name: 'cageCorner',
    type: 'gltfModel',
    path: '/3d_models/nido_cage_c.glb',
  },
  {
    name: 'cageWoodenSingle',
    type: 'gltfModel',
    path: '/3d_models/nido_cage_1_wood.glb',
  },
  {
    name: 'cageWoodenDouble',
    type: 'gltfModel',
    path: '/3d_models/nido_cage_2_wood.glb',
  },
  {
    name: 'cageWoodenTriple',
    type: 'gltfModel',
    path: '/3d_models/nido_cage_3_wood.glb',
  },
  {
    name: 'cageWoodenCorner',
    type: 'gltfModel',
    path: '/3d_models/nido_cage_c_wood.glb',
  },
  {
    name: 'ldsLogo',
    type: 'gltfModel',
    path: '/3d_models/ldseating.glb',
  },
]

export { sources }

export type { Source }
